import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import Button from 'components/Button/Button';

import {
  Drawer,
  DrawerBodyStyle,
} from 'modules/Header/components/Header.styled';

const isMac = navigator.platform.indexOf('Mac') > -1;

const KeyboardShortcuts = ({ isActive, setShowKeyboardShortcuts }) => (
  <>
    {isActive && <DrawerBodyStyle />}
    <Drawer
      style={
        isActive
          ? { transform: 'translateX(0)' }
          : { transform: 'translateX(105%)' }
      }>
      {isActive && (
        <>
          <div className="drawer-header">
            <div>
              <Icon
                name="keyboard"
                verticalAlign="sub"
                width="20"
                height="20"
              />
              &emsp;Keyboard Shortcuts
            </div>
            <Button
              type="button"
              unstyled
              onClick={() => {
                setShowKeyboardShortcuts(false);
              }}>
              <Icon name="close" width="16" height="16" />
            </Button>
          </div>
          <div className="drawer-content">
            <ul>
              <li>
                <span>Bold text</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>B</code>
                </span>
              </li>
              <li>
                <span>Underline text</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>U</code>
                </span>
              </li>
              <li>
                <span>Italicize text</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>I</code>
                </span>
              </li>
              <li>
                <span>Undo changes</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>Z</code>
                </span>
              </li>
              <li>
                <span>
                  Move objects
                  <br />
                  by 10px
                </span>
                <span>
                  <code>Shift</code>
                  <code>Arrows</code>
                </span>
              </li>
              <li>
                <span>Tag members in comments</span>
                <span>
                  <code>@</code>
                </span>
              </li>
              <li>
                <span>
                  Detect spacing
                  <br />
                  between objects
                </span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>Hover</code>
                </span>
              </li>
              <li>
                <span>Toggle between views</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>L/R Arrows</code>
                </span>
              </li>
              <li>
                <span>Edit mode</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  <code>J</code>
                </span>
              </li>
              <li>
                <span>
                  Click actionable
                  <br />
                  elements
                </span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>Click</code>
                </span>
              </li>
              <li>
                <span>Open/close popups</span>
                <span>
                  <code>{isMac ? 'Cmd' : 'Ctrl'}</code>
                  <code>Click</code>
                </span>
              </li>
            </ul>
          </div>
        </>
      )}
    </Drawer>
  </>
);

KeyboardShortcuts.propTypes = {
  isActive: PropTypes.bool.isRequired,
  setShowKeyboardShortcuts: PropTypes.func.isRequired,
};

export default KeyboardShortcuts;
